import React, {Component} from 'react';
import {
    View,
    TouchableOpacity,
    Platform,
    Text

} from "react-native"
import {typeExport} from "./../redux/store/type";
import {moderateScale} from "./../tools/Scaling";
import i18n from "../I18n/i18n";
//import {Tools} from "../tools/Tools";
import {CheckValue, numberWithCommas} from "../tools/Tools1";
import Hyperlink from "./Hyperlink";
import * as Colors from "../tools/Colors";

let HyperlinkView = null;
export default class HMTextView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            // value: 'احمد'
        }
    }


    componentWillReceiveProps(props) {


    }


    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }


    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {text, styleRoot, style, type, cammas, lang, linkStyle, linkText, onPressLink, HyperlinkCheck, numberOfLines, _children, CustomeView} = this.props;
        // text = (text != "0" ? Tools.CheckValue(text) : "0");
        text = (text != "0" ? CheckValue(text) : "0");

        text = lang ? i18n.t(text) : text;

        HyperlinkView = HyperlinkCheck ? Hyperlink : (onPressLink ? TouchableOpacity : View);
        return (

            <HyperlinkView
                linkStyle={linkStyle}
                onPress={onPressLink}
                linkText={linkText}
                style={[{flexDirection: 'row',}, styleRoot]}
            >
                <Text
                    numberOfLines={numberOfLines}
                    ellipsizeMode='tail'
                    style={[Platform.OS === 'ios' ? {textAlign: 'left'} : {}, {

                        color: Colors.gray,
                        fontSize: moderateScale(14),
                        //fontWeight: type === "bold" ?  "500" : "300",
                        // fontWeight: Platform.OS === "ios" ? (type === "bold" ? "700" : (type === "light" ? "300" : "400")) : null,
                        //fontWeight: type === "bold" ? (Platform.OS === "ios" || Platform.OS === "web" ? "700" : (type === "light" ? "300" : "500")) : "500",
                        //  fontFamily: typeExport.regularFontName,
                        fontFamily: (Platform.OS === "ios" ? typeExport.regularFontName : (type === "bold" ? typeExport.boldFontName : (type === "light" ? typeExport.lightFontName : typeExport.regularFontName))),
                        // fontFamily:  typeExport.regularFontName,
                        //src: `local('IRANSansWeb(FaNum)'), url(../assets/fonts/IRANSansWeb(FaNum).ttf) format('truetype')`,
                        //lineHeight: style&&style.lineHeight?style.lineHeight:moderateScale(22),


                    }, Platform.OS === "web" ?
                        {
                            textOverflow: "ellipsis",
                            fontWeight: type === "bold" ? (Platform.OS === "ios" || Platform.OS === "web" ? "700" : (type === "light" ? "300" : "500")) : "500",
                        }
                        :
                        {
                            fontWeight: Platform.OS === "ios" ? (type === "bold" ? "700" : (type === "light" ? "300" : "400")) : null,
                        }
                        , Platform.OS === "web" ? {textOverflow: "ellipsis",} : {}, style]}>
                    {
                        _children ?
                            this.props.children
                            :
                            ((text === null || text === "null" || text === undefined || text === "undefined") ? '' : !cammas ? String(text) : numberWithCommas(text))
                    }
                </Text>
                {
                    CustomeView ? CustomeView() : null
                }
            </HyperlinkView>

        );
    }


}
